import { Box, Circle, Flex, Img, ScaleFade, Stack, Text, VStack } from '@chakra-ui/react';
import React, { useContext, useEffect, useState } from 'react';
import Container from '../../components/Container';
import Header from '../../components/Header';
import HeadSeemore from '../../components/HeadSeemore';
import OffersCard from './components/OffersCard';
import OfferWithPrice from './components/OfferWithPrice';
import Footer from '../../components/footer';
import { BsPlusLg } from 'react-icons/bs';
import { Link, useNavigate } from 'react-router-dom';
import { PROTECTED_PATHS } from '../../app/constants';
import { getOffers } from './service/offer';
import { AuthContext } from '../../context/authContext';
import FullPageLoader from '../../components/FullPageLoader';
import { v4 } from 'uuid';
import { getAdvertProducts } from './service/topProducts';
import { CarouselProvider, Slide, Slider } from 'pure-react-carousel';
import { getCategories, getMarketplaceBanner } from './service';
import { dynamicPathhandler } from '../../components/utils/dynamicPathHandler';
import { PrimaryButton } from '../../components/CustomButton';
import { transition } from '../..';

const MarketPalce = () => {
  const { POST_ADVERT, ALL_OFFERS, CATEGORY } = PROTECTED_PATHS;
  const { userInfo } = useContext(AuthContext);
  const { userId } = userInfo;
  const [loading, setLoading] = useState(false);
  const [offers, setOffers] = useState([]);
  const [advertProducts, setAdvertProducts] = useState([]);
  const numberOfAdvertsToRender = 3;
  const [advertTorender, setAdvertTorender] = useState(numberOfAdvertsToRender);
  const [banner, setBanner] = useState([]);
  const [categories, setCategories] = useState([]);
  const navigate = useNavigate();
  const parentPath = dynamicPathhandler(CATEGORY);

  useEffect(() => {
    getOffers(userId, setLoading, setOffers);
    getAdvertProducts(userId, setLoading, setAdvertProducts);
    getMarketplaceBanner(userId, setLoading, setBanner);
    getCategories(userId, setLoading, setCategories);
  }, [userId]);

  const handleLoadMore = () => {
    setAdvertTorender(advertTorender + numberOfAdvertsToRender);
  };

  return loading ? (
    <FullPageLoader />
  ) : (
    <ScaleFade initialScale={0.3} in={true} {...transition}>
      <Box>
        <Box shadow='sm'>
          <Container>
            <Header menu />
          </Container>
        </Box>

        <Stack bg='#F4F0F094' py='5'>
          <Container pos='relative'>
            <Stack spacing={'5'}>
              {/* <SearchBar to={FILTER_PAGE} /> */}

              <CarouselProvider
                infinite={true}
                visibleSlides={1}
                dragEnabled={false}
                isPlaying={true}
                naturalSlideWidth={120}
                naturalSlideHeight={80}
                totalSlides={banner?.length}
              >
                <Slider>
                  {banner &&
                    banner?.map((b) => (
                      <Slide key={v4()}>
                        <Img {...flasSaleImageStyles} src={b?.imageUrl} />
                      </Slide>
                    ))}
                </Slider>
              </CarouselProvider>

              <Box pt='5'>
                <HeadSeemore head='Categories' />
              </Box>

              <Flex gap='1rem' wrap='wrap'>
                {categories?.map((category, index) => (
                  <VStack
                    className='category-container'
                    key={index}
                    onClick={() => navigate(`${parentPath}/${category?.categoryName.toLowerCase()}`)}
                  >
                    <Img h='80px' w='100%' objectFit='cover' borderRadius='2px' src={category?.image} alt={category?.categoryName} />

                    <Text textAlign='center' fontSize='12px' fontWeight='600'>
                      {category?.categoryName}
                    </Text>
                  </VStack>
                ))}
              </Flex>
              {/* post advert button */}
              <Circle zIndex='10' className='plus' bg='primary'>
                <Link to={POST_ADVERT}>
                  <BsPlusLg size={20} />
                </Link>
              </Circle>

              <Box py='5'>
                <HeadSeemore head='Offers' seemore to={ALL_OFFERS} />

                <CarouselProvider
                  infinite={true}
                  visibleSlides={3}
                  dragEnabled={true}
                  isPlaying={true}
                  naturalSlideWidth={120}
                  naturalSlideHeight={170}
                  totalSlides={offers?.offers?.length}
                >
                  <Slider>
                    {offers?.offers?.map((offer, index) => (
                      <Slide key={v4()} index={index}>
                        <OffersCard {...offer} />
                      </Slide>
                    ))}
                  </Slider>
                </CarouselProvider>
              </Box>

              <Stack spacing='5'>
                <HeadSeemore head='Top Products' />
                {advertProducts?.slice(0, advertTorender)?.map((advert) => (
                  <OfferWithPrice key={v4()} advert={advert} />
                ))}

                <Box py='10' pb='20'>
                  {advertTorender < advertProducts?.length && <PrimaryButton btnText='Load More' onClick={handleLoadMore} />}
                </Box>
              </Stack>
            </Stack>
          </Container>
          <Footer />
        </Stack>
      </Box>
    </ScaleFade>
  );
};

export default MarketPalce;

const flasSaleImageStyles = {
  w: '100%',
  h: '100%',
  objectFit: 'cover',
  borderRadius: '5px',
  alt: 'flash sales',
};
